import React, { useState } from 'react'
import { useSelector } from 'react-redux'
import { Box, Typography } from 'transfix-ui/core'
import { ICarrierState } from 'types/carrier'
import { IMotorCarrierInsuranceContact } from 'types/graphqlTypes'
import useUserDetails from 'utils/hooks/useUserDetails'
import { IStore } from 'apps/carrier/utils/reducers'
import { Button, INLINE_MESSAGE_VARIANTS, InlineMessage } from 'transfix-ui'
import { AddInsuranceContactInformationModal } from '../../../Insurance/AddInsuranceContactInformationModal'
import { LoadableValue } from '../../../LoadableValue'
import { useInsuranceContactsQuery } from '../graphql/InsuranceContacts'
import { InsuranceAgentCard } from './InsuranceAgentCard'

const AgentInformation = () => {
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false)

  const { userPermissions } = useUserDetails()
  const { canAddInsuranceDocuments, canEditComplianceCarrierInfo } = userPermissions || {}

  const { carrierDetails } = useSelector<IStore, ICarrierState>(({ carrier }) => carrier)
  const { id: carrierId = '' } = carrierDetails || {}
  const {
    data: agentsData,
    error: agentsError,
    loading: agentsLoading,
    refetch: agentsRefetch,
  } = useInsuranceContactsQuery({
    variables: {
      carrierApplicationId: `${carrierId}`,
    },
  })
  const { insuranceContacts = [] } = agentsData || {}

  const openHandler = () => {
    setIsModalOpen(true)
  }

  const closeHandler = () => {
    setIsModalOpen(false)
  }

  const SubmitAgentContactDetailsButton = () => {
    return canAddInsuranceDocuments || canEditComplianceCarrierInfo ? (
      <Button variant='text' onClick={openHandler}>
        Submit Agent Contact Details
      </Button>
    ) : (
      <div />
    )
  }

  if (!carrierId) return null

  return (
    <Box width='100%'>
      <AddInsuranceContactInformationModal
        carrierApplicationId={parseInt(carrierId, 10)}
        open={isModalOpen}
        onClose={closeHandler}
        refetch={agentsRefetch}
      />
      <Box display='flex' justifyContent='space-between' alignItems='center'>
        <Typography variant='subtitle1'>Agent Information</Typography>
        <SubmitAgentContactDetailsButton />
      </Box>
      <Box mb={2} mt={3} overflow='auto' display='flex'>
        {agentsLoading && <LoadableValue loading value='' />}
        {!agentsLoading && !insuranceContacts?.length && (
          <Typography variant='caption' color='textSecondary'>
            No Reported Data
          </Typography>
        )}
        {!!insuranceContacts?.length &&
          insuranceContacts?.map((agent: IMotorCarrierInsuranceContact) => (
            <InsuranceAgentCard key={agent.id} agent={agent} />
          ))}
      </Box>
      {agentsError && (
        <InlineMessage type={INLINE_MESSAGE_VARIANTS.ALERT} message={agentsError.message} />
      )}
    </Box>
  )
}

export default AgentInformation
